// Fallback images for room types when the backend hasn't got photos yet.
// These are NUVA's own room shots bundled with the app (same set the seed
// command uploads to the backend), so a fallback never shows another hotel.

const SENCILLA = '/images/nuva/rooms/room-sencilla-queen-hero.jpeg'
const DELUXE = '/images/nuva/rooms/room-deluxe-queen-hero.jpeg'
const DELUXE_BALCONY = '/images/nuva/rooms/room-deluxe-queen-balcony-hero.jpeg'
const JUNIOR_SUITE = '/images/nuva/rooms/room-junior-suite-king-hero.jpeg'
const DOBLE = '/images/nuva/rooms/room-doble-queen-hero.jpeg'
const MASTER = '/images/nuva/rooms/room-master-suite-hero.jpeg'

export function roomImageFallback(name: string): string {
  const n = name.toLowerCase()
  if (n.includes('balcon') || n.includes('balcón') || n.includes('balcony')) return DELUXE_BALCONY
  if (n.includes('junior') || n.includes('king')) return JUNIOR_SUITE
  if (n.includes('master') || n.includes('triple') || n.includes('familiar') || n.includes('suite')) return MASTER
  if (n.includes('doble') || n.includes('twin') || n.includes('double')) return DOBLE
  if (n.includes('sencilla') || n.includes('single') || n.includes('individual')) return SENCILLA
  return DELUXE
}

export const ROOM_FALLBACK_GALLERY = [SENCILLA, DELUXE, DELUXE_BALCONY, JUNIOR_SUITE, DOBLE, MASTER]
